import React from 'react';
import { Spin, SpinProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined spin />;

const Spinner = (props: SpinProps) => {
  return <Spin {...props} indicator={antIcon} />;
};

export default Spinner;
